export class UserValidationError extends Error {
  todo: string;

  constructor(message: string, todo: string) {
    super(message);
    this.name = "UserValidationError";
    this.todo = todo;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class BackendResponseError extends Error {
  todo: string;

  constructor(message: string, todo: string = null) {
    super(message);
    this.name = "BackendResponseError";
    this.todo = todo;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
